"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var ActionSection_1 = __importDefault(require("@/Jetstream/ActionSection"));
var DangerButton_1 = __importDefault(require("@/Jetstream/DangerButton"));
var DialogModal_1 = __importDefault(require("@/Jetstream/DialogModal"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var InputError_1 = __importDefault(require("@/Jetstream/InputError"));
var SecondaryButton_1 = __importDefault(require("@/Jetstream/SecondaryButton"));
function DeleteUserForm() {
    var route = (0, useRoute_1.default)();
    var _a = (0, react_1.useState)(false), confirmingUserDeletion = _a[0], setConfirmingUserDeletion = _a[1];
    var form = (0, inertia_react_1.useForm)({
        password: '',
    });
    var passwordRef = (0, react_1.useRef)(null);
    function confirmUserDeletion() {
        setConfirmingUserDeletion(true);
        setTimeout(function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 250);
    }
    function deleteUser() {
        form.delete(route('current-user.destroy'), {
            preserveScroll: true,
            onSuccess: function () { return closeModal(); },
            onError: function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); },
            onFinish: function () { return form.reset(); },
        });
    }
    function closeModal() {
        setConfirmingUserDeletion(false);
        form.reset();
    }
    return (react_1.default.createElement(ActionSection_1.default, { title: 'Delete Account', description: 'Permanently delete your account.' },
        react_1.default.createElement("div", { className: "max-w-xl text-sm text-gray-600" }, "Once your account is deleted, all of its resources and data will be permanently deleted. Before deleting your account, please download any data or information that you wish to retain."),
        react_1.default.createElement("div", { className: "mt-5" },
            react_1.default.createElement(DangerButton_1.default, { onClick: confirmUserDeletion }, "Delete Account")),
        react_1.default.createElement(DialogModal_1.default, { isOpen: confirmingUserDeletion, onClose: closeModal },
            react_1.default.createElement(DialogModal_1.default.Content, { title: 'Delete Account' },
                "Are you sure you want to delete your account? Once your account is deleted, all of its resources and data will be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.",
                react_1.default.createElement("div", { className: "mt-4" },
                    react_1.default.createElement(Input_1.default, { type: "password", className: "mt-1 block w-3/4", placeholder: "Password", value: form.data.password, onChange: function (e) { return form.setData('password', e.currentTarget.value); } }),
                    react_1.default.createElement(InputError_1.default, { message: form.errors.password, className: "mt-2" }))),
            react_1.default.createElement(DialogModal_1.default.Footer, null,
                react_1.default.createElement(SecondaryButton_1.default, { onClick: closeModal }, "Cancel"),
                react_1.default.createElement(DangerButton_1.default, { onClick: deleteUser, className: (0, classnames_1.default)('ml-2', { 'opacity-25': form.processing }), disabled: form.processing }, "Delete Account")))));
}
exports.default = DeleteUserForm;
